import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
  AnalyticsTrigger,
  Button,
  Card,
  CardContent,
  EqualHeight,
  Icon,
  Modal,
  ModalContent,
  ModalProvider,
  ModalTrigger,
  Separator,
  Text,
} from 'telia-front-react';
import GravityForm from '../../../forms/GravityForm';
import InternetCalculatorStore from '../../../stores/InternetCalculatorStore';

interface Props {
  specialRequestFormName: string;
  calculatorKey: string;
  noEmptySpaceOnTop?: boolean;
  internetCalculatorStore?: InternetCalculatorStore;
}

const SpecialRequestCard: React.FC<Props> = ({ specialRequestFormName, calculatorKey, noEmptySpaceOnTop, internetCalculatorStore }) => {
  const translate = React.useContext(TranslationsContext).translate;
  const cmsDataStoreKeys = internetCalculatorStore.getCmsStoreKeys(calculatorKey);

  return (
    <AnalyticsTrigger
      trigger={{
        id: ([isOpen]) => `CTA - ${isOpen ? 'open' : 'close'} Form - Eripakkumise sooviavaldus`,
        callback: 'onToggle',
      }}
    >
      <ModalProvider isClosable={true}>
        <Card type="light" background="neutral-bg-level-1" className="text-left" elevation={1}>
          <CardContent tagTop={noEmptySpaceOnTop ? null : true}>
            <Text>
              <EqualHeight group="internet-speed">
                <Separator color={'invisible'} spacing={'xxsmall'} />
                <Icon size={'lg'} modifiers={'#rocket'} />
              </EqualHeight>
              <EqualHeight group="card-text">
                <p>{translate('internetAndTvCalculator.requestSpecialOffer.text')}</p>
              </EqualHeight>
              <EqualHeight group="price">
                <div />
              </EqualHeight>
              <ModalTrigger>
                <Button
                  className="text__margin-double"
                  iconRight={'#arrow-right'}
                  id={'request-special-internet-button'}
                  text={translate('internetAndTvCalculator.requestSpecialOffer.button')}
                  variant="secondary"
                  block={true}
                />
              </ModalTrigger>
            </Text>
          </CardContent>
          <Modal isClosable={true} hasContentComponent={true}>
            <ModalContent>
              <GravityForm
                name={specialRequestFormName}
                fieldValueProviders={[
                  {
                    data: cmsDataStoreKeys.addressKey,
                    technicalParameter: 'internet_address',
                  },
                  {
                    data: cmsDataStoreKeys.roomKey,
                    technicalParameter: 'internet_room',
                  },
                  {
                    data: cmsDataStoreKeys.addressIdKey,
                    technicalParameter: 'internet_address_id',
                  },
                  {
                    data: cmsDataStoreKeys.buildingIdKey,
                    technicalParameter: 'internet_building_id',
                  },
                  {
                    data: cmsDataStoreKeys.apartmentIdKey,
                    technicalParameter: 'internet_apartment_id',
                  },
                  {
                    data: cmsDataStoreKeys.plannedInternetKey,
                    technicalParameter: 'internet_package',
                  },
                ]}
                cmsData={internetCalculatorStore.getCmsData(calculatorKey)}
              />
            </ModalContent>
          </Modal>
        </Card>
      </ModalProvider>
    </AnalyticsTrigger>
  );
};

export default inject('internetCalculatorStore')(observer(SpecialRequestCard));
